<template>
  <div>
    <v-container class="grey lighten-5" v-if="$route.name == 'file'">
      <v-row no-gutters>
        <v-col cols="12" sm="2">
          <div style="overflow: scroll; width: 100%; height: 500px">
            <v-treeview
              :open="open"
              :items="items"
              activatable
              item-key="name"
              open-on-click
            >
              <template v-slot:prepend="{ item, open }">
                <v-icon v-if="!item.file">
                  {{ open ? "mdi-folder-open" : "mdi-folder" }}
                </v-icon>
              </template>
              <template v-slot:label="{ item }">
                <div
                  @click="getFile(item.uuid, 1)"
                  style="width: 100%; heightl: 100%; position: absolue"
                >
                  {{ INT(item.directory_name) }}
                </div>
              </template>
            </v-treeview>
          </div>
        </v-col>
        <v-col cols="12" sm="10"
          ><div
            style="width: 100%; height: 100%; border-left: 1px solid #dcdcdc"
          >
            <div
              class="d-flex"
              style="
                width: 96%;
                height: 60px;
                border-bottom: 1px solid #dcdcdc;
                margin-left: 17px;
                padding-top: 10px;
              "
            >
              <a
                @click="checkboxDel"
                class="functionButton"
                v-if="buttonrole.new_folder"
              >
                <v-icon class="material-icons"> mdi-folder-plus </v-icon>
                <span>
                  {{ $t("label_001-018_001-017-003_new_folder_key") }}
                </span>
              </a>
              <a
                @click="checkboxDel"
                class="functionButton"
                v-if="buttonrole.delete"
              >
                <v-icon class="material-icons"> mdi-delete </v-icon>
                <span> {{ $t("label_delete") }}</span>
              </a>
              <a
                @click="handleAdd"
                class="functionButton"
                v-if="buttonrole.upload"
              >
                <mrc_ess_svgIcon
                  style="font-size: 170%"
                  icon-class="file_upload_black"
                ></mrc_ess_svgIcon>
                <span>{{ $t("label_001-018_001-017-003_upload_key") }}</span>
              </a>
              <a
                @click="batchDownload"
                class="functionButton"
                v-if="buttonrole.download"
              >
                <mrc_ess_svgIcon
                  style="font-size: 170%"
                  icon-class="file_download_black"
                ></mrc_ess_svgIcon>
                <span>{{
                  $t("label_001-018_001-017-003_lable_download")
                }}</span>
              </a>
              <a
                class="functionButton"
                v-if="buttonrole.move_to"
                @click="moveTo"
              >
                <v-icon class="material-icons"> mdi-folder-move </v-icon>
                <span>{{ $t("label_001-018_001-017-003_move_to_key") }}</span>
              </a>
            </div>
            <div class="pl-8 mt-4">
              <a
                class="filePath"
                v-for="(item, index) in file_path"
                :key="index"
              >
                <span @click="getFile(item.uuid)"
                  >[{{ INT(item.directory_name) }}]</span
                >
                <span v-if="index != file_path.length - 1" class="mx-3">></span>
              </a>
            </div>
            <mrc_ess_myDialog
              v-model="dialog"
              :title="$t('label_001-018_001-017-003_rename_key')"
              :width="400"
              @success="telsave"
              @cancel="telclose"
            >
              <input
                id="renameText"
                type="text"
                :value="getFileName(renameobj)"
                style="border: 1px solid #696969; width: 330px"
              />
            </mrc_ess_myDialog>
            <mrc_ess_table
              showSelect
              :headers="headers"
              :draggableStatus="false"
              :hideAddBtn="true"
              :paginationOptions="paginationOptions"
              @turnPage="getFile(click_file_uuid)"
              :slotKey="['file_name']"
              :items="file"
              ref="checkboxs"
            >
              <template v-slot:item.file_name="{ item }">
                <v-icon>
                  {{ files[item.file_type] }}
                </v-icon>
                {{ item.file_name }}
              </template>
              <template v-slot:item.actions="{ item }">
                <menu-list
                  :list="list"
                  @handleClick="handleClick($event, item)"
                >
                  <template v-slot:showAction>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </template>
                </menu-list>
              </template>
            </mrc_ess_table>
          </div>
          <move ref="move" @fatherMethod="getFile"></move>
        </v-col>
      </v-row>
    </v-container>
    <router-view></router-view>
  </div>
</template>
<script>
import { file_tree, get_file, del_file, rename } from "@/service/api/file"
import { findSrc } from "@/service/api/upload.js"
import move from "./components/move"
export default {
  components: {
    move,
  },
  data() {
    return {
      file_path: {},
      buttonrole: {
        new_folder: false,
        delete: false,
        upload: false,
        download: false,
        move_to: false,
        view: false,
        update: false,
      },
      role: "",
      renameobj: {},
      dialog: false,
      selected: [],
      open: ["public"],
      files: {
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-json",
        md: "mdi-markdown",
        pdf: "mdi-file-pdf",
        png: "mdi-file-image",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
        docx: "mdi-file-word",
        xlsx: "mdi-file-excel",
      },
      field_alias_name: null,
      table_alias_name: null,
      click_file_uuid: "",
      file: [],
      items: [],
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      fileInfo: [],
    }
  },

  filters: {},
  mounted() {
    this.fileTree()
    this.getFile(this.click_file_uuid)
  },
  watch: {
    $route(v) {
      if (v.name == "file") {
        this.getFile(this.click_file_uuid)
      }
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_001-018_001-017-003_lable_file_key"), //国际化key
          align: "start",
          sortable: false,
          value: "file_name", //字段名
        },

        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
    list() {
      return [
        {
          name: this.$t("label_View"),
          show: this.buttonrole.view,
          type: "view",
        },
        // {
        //   name: this.$t("label_Edit"),
        //   show: true,
        //   type: "edit",
        // },
        {
          name: this.$t("label_delete"),
          show: this.buttonrole.delete,
          type: "del",
        },
        {
          name: this.$t("label_001-018_001-017-003_lable_download"),
          show: this.buttonrole.download,
          type: "download",
        },
        {
          name: this.$t("label_001-018_001-017-003_rename_key"),
          show: this.buttonrole.update,
          type: "rename",
        },
      ]
    },
  },

  methods: {
    moveTo() {
      var arr = this.$refs.checkboxs.selected
      if (arr.length > 0) {
        this.$refs.move.startUp(arr)
      } else {
        this.$Message({
          text: this.$t(
            "label_001-018_001-017-003_please_select_the_moved_file"
          ),
        })
      }
    },
    getrole() {
      var bottom_arr = this.role.split(",")
      this.buttonrole.view = false
      this.buttonrole.download = false
      this.buttonrole.upload = false
      this.buttonrole.update = false
      this.buttonrole.delete = false
      this.buttonrole.move_to = false
      this.buttonrole.new_folder = false
      bottom_arr.forEach((element) => {
        if (element == "1") {
          this.buttonrole.view = true
        }
        if (element == "2") {
          this.buttonrole.download = true
        }
        if (element == "3") {
          this.buttonrole.upload = true
        }
        if (element == "4") {
          this.buttonrole.update = true
        }
        if (element == "5") {
          this.buttonrole.delete = true
        }
        if (element == "6") {
          this.buttonrole.move_to = true
        }
        if (element == "0") {
          this.buttonrole.new_folder = true
        }
      })
    },
    getFileName(obj) {
      return String(obj.file_name).replace("." + obj.file_type, "")
    },
    async telsave() {
      let renameText = document.getElementById("renameText").value
      this.renameobj.file_name = renameText + "." + this.renameobj.file_type
      var ok = await rename(this.renameobj)

      if (ok.code == 200) {
        this.renameobj = {}
        this.dialog = false
        this.$Message({
          text: this.$t("message_The_operation_was_successful"),
        })
      }
    },
    telclose() {
      this.renameobj = {}
    },
    checkboxDel() {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          var arr = this.$refs.checkboxs.selected
          var uuid_arr = []
          var name_arr = []

          arr.forEach((element) => {
            uuid_arr.push(element.uuid)
            name_arr.push(element.file_name)
            if (element.attachments_uuid != "") {
              findSrc({ uuid: element.attachments_uuid }).then((res) => {
                if (res.data.files.length > 0) {
                  this.$deleteFile(res.data.files[0].uuid)
                }
              })
            }
          })

          var del = await del_file({
            uuid: uuid_arr.join(","),
            file_name: name_arr.join(","),
          })
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            })

            if (this.file.length === 1 && this.paginationOptions.cpage > 1) {
              this.paginationOptions.cpage--
            }

            await this.getFile(this.click_file_uuid)
          }
        })
        .catch(() => {})
    },
    handleAdd() {
      if (!this.click_file_uuid) {
        this.$Message({
          text: this.$t("label_001-018_001-017-003_control_file"),
        })
        return
      }
      this.$router.push({
        name: "addFile",
        query: {
          file_uuid: this.click_file_uuid,
        },
      })
    },
    async fileTree() {
      var tree = await file_tree({
        org_level_uuid: this.$store.state.currentCompany,
        directory_type: 1,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })

      this.items = tree.data
    },
    async getFile(uuid, cpage) {
      if (uuid) {
        this.click_file_uuid = uuid
      }

      if (cpage) {
        this.paginationOptions.cpage = cpage
        this.$store.state.cpage = cpage
      } else {
        this.paginationOptions.cpage = this.$store.state.cpage
      }

      var fileDate = await get_file({
        directory_uuid: this.click_file_uuid,
        directory_type: 1,
        pagesize: this.paginationOptions.pagesize,
        cpage: this.paginationOptions.cpage,
      })

      if (fileDate) {
        this.file = fileDate.dataTable

        if (fileDate.data) {
          this.role = fileDate.data.button
        }

        this.file_path = fileDate.file_list
        this.getrole()
      }

      this.paginationOptions.totalcount = fileDate.totalcount
      this.paginationOptions.totalpage = fileDate.totalpage
    },
    async getDetail(attachments_uuid) {
      if (attachments_uuid) {
        await findSrc({ uuid: attachments_uuid }).then((res) => {
          if (res.data.files.length > 0) {
            this.fileInfo = res.data.files
          }
        })
      }
    },
    async batchDownload() {
      var data_arr = this.$refs.checkboxs.selected

      var uuid_arr = []
      data_arr.forEach((element) => {
        let auuid = element.attachments_uuid
        uuid_arr.push(auuid)
      })
      findSrc({ uuid: uuid_arr.join(",") }).then((res) => {
        if (res.data.files.length > 0) {
          this.$batchDownload(res.data.files)
        }
      })
    },
    download(val) {
      const links = document.createElement("a")
      // let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      links.style.display = "none"
      //设置连接

      links.href = val.path
      links.download = val.name
      document.body.appendChild(links)
      //模拟点击事件
      links.click()
      document.body.removeChild(links)
    },
    delFile(list) {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          var del = await del_file({
            uuid: list.uuid,
            file_name: list.file_name,
          })
          if (del.code == 200) {
            this.$deleteFile(list.uuid)
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            })

            if (this.file.length === 1 && this.paginationOptions.cpage > 1) {
              this.paginationOptions.cpage--
            }

            await this.getFile(this.click_file_uuid)
          }
        })
        .catch(() => {})
    },
    async handleClick({ item, index }, obj) {
      await this.getDetail(obj.attachments_uuid)
      if (item.type == "view") {
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", true)
        this.$router.push({
          name: "fileInfo",
          query: {
            listuuid: obj.uuid,
            file_name: obj.file_name,
            attachments_uuid: obj.attachments_uuid,

            file_uuid: this.click_file_uuid,
          },
        })
      }
      if (item.type == "del") {
        obj["path"] = this.fileInfo[0].path
        this.delFile(obj)
      }
      if (item.type == "rename") {
        this.dialog = true
        this.renameobj = obj
      }
      if (item.type == "edit") {
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "fileInfo",
          query: {
            listuuid: obj.uuid,
            file_name: obj.file_name,
            attachments_uuid: obj.attachments_uuid,
            file_uuid: this.click_file_uuid,
          },
        })
      }
      if (item.type == "download") {
        this.download(this.fileInfo[0])
      }
    },
  },
}
</script>
<style scoped>
.functionButton {
  padding-left: 18px !important;
  color: #383838;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.filePath {
  color: #383838;
}
.filePath :hover {
  color: #0f46c1;
}
.functionButton :hover {
  color: #0f46c1;
}
</style>
